var init = require("init");
var scrolling = false;

var map;
var mapBoundries;
var markers = new Array();
var markerCluster;
var lastSearch = "";
var mapLoaded = false;

init.then(function (init) {
    require("../sass/normalize.scss");

    require("@material/layout-grid/mdc-layout-grid.scss");
    require("@material/dialog/mdc-dialog.scss");
    require("@material/card/mdc-card.scss");
    require("@material/menu/mdc-menu.scss");
    require("@material/list/mdc-list.scss");
    require("@material/tab/mdc-tab.scss");
    require("@material/chips/mdc-chips.scss");

    require("@os/mdc/dialog.scss");
    require("@os/mdc/button.scss");
    require("@os/mdc/layout-grid.scss");
    require("@os/mdc/text-field.scss");
    require("@os/list/list.scss");
    require("@os/typography/typography.scss");
    require("@os/helper/helper.scss");

    require("../sass/bottom-contact/bottom-contact.scss");
    require("../sass/plain-overlay/plain-overlay.scss");
    require("../sass/search/search.scss");
    require("../sass/search-header/search-header.scss");
    require("../sass/search-box/search-box.scss");
    require("../sass/search-box-fields/search-box-fields.scss");
    require("../sass/search-box-map/search-box-map.scss");
    require("../sass/search-content/search-content.scss");
    require("../sass/search-landing-statistics/search-landing-statistics.scss");
    require("../sass/search-landing-statistics-box/search-landing-statistics-box.scss");
    require("../sass/search-green-bar/search-green-bar.scss");
    require("../sass/search-no-result/search-no-result.scss");
    require("../sass/search-callto-action/search-callto-action.scss");
    require("../sass/search-page-footer/search-page-footer.scss");
    require("../sass/search-result-filter-bar/search-result-filter-bar.scss");
    require("../sass/search-result-pill-container/search-result-pill-container.scss");
    require("../sass/search-result-listing/search-result-listing.scss");
    require("../sass/search-result-item/search-result-item.scss");
    require("../sass/search-review-redirect-immoreviews/search-review-redirect-immoreviews.scss");

    //require('material-design-icons/iconfont/material-icons.css');

    var templateBody = require("../view/search.hbs");
    var templateSearchCityList = require("../view/search-city-list.hbs");
    var templateSearchResult = require("../view/search-result.hbs");
    var templateSearchReviewRedirectImmoreviews = require("../view/search-review-redirect-immoreviews.hbs");

    define([
        "jquery",
        "js-cookie",
        "@material/ripple",
        "i18next",
        "jquery-match-height",
        "@material/menu",
        "@material/textfield",
        "@material/tab",
        "load-google-maps-api",
        "@google/markerclusterer",
        "@os/header",
        "@os/footer",
        "@os/recommend-company",
        "@os/survey-request",
        "@os/message-bar",
        "@material/dialog",
    ], function (
        $,
        jsCookie,
        mdcRipple,
        i18next,
        jqueryMatchHeight,
        mdcMenu,
        mdcTextField,
        mdcTab,
        loadGoogleMapsApi,
        markerClusterer,
        header,
        footer,
        recommendCompany,
        surveyRequest,
        messageBar,
        mdcDialog,
    ) {
        jQuery = $;
        require("jquery-plainoverlay");
        var resizeTimer;

        $(function () {
            $("a.fusion-link").on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                $("#awb-oc-504").addClass("awb-show");
            });

            $(".off-canvas-close").on("click", function (e) {
                e.preventDefault();
                e.stopPropagation();
                $("#awb-oc-504").removeClass("awb-show");
            });
            var groupId = window.location.href.substr(
                window.location.href.lastIndexOf("/") + 1,
            );
            if (isNaN(groupId)) {
                groupId = null;
            }

            $(window).on("resize", function (e) {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    $.fn.matchHeight._apply(".search-callto-action__box", {
                        property: "min-height",
                    });
                }, 250);
            });

            $(document).on("click", function (e) {
                if (
                    !$(e.target).parents(
                        ".search-box-fields__city-autocomplete-list",
                    ).length
                ) {
                    $(".search-box-fields__city-autocomplete-list").each(
                        function () {
                            $(this).hide();
                        },
                    );
                }
            });

            $(document).on(
                "keyup",
                'form[name="form_search"] input[name="location"]',
                function (e) {
                    if (e.keyCode != 13 && $(this).val().length >= 3) {
                        $.ajax({
                            type: "POST",
                            url: "/api/search/cities",
                            data: {
                                location: $(this).val(),
                            },
                            dataType: "json",
                        }).done(function (data) {
                            if (data.city.length) {
                                $(".search-box-fields__city-autocomplete-list")
                                    .empty()
                                    .append(templateSearchCityList(data))
                                    .show();
                            } else {
                                $(
                                    ".search-box-fields__city-autocomplete-list",
                                ).hide();
                            }
                        });
                    }
                },
            );

            $(document).on(
                "click",
                'a[data-action="trigger-location"]',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(showPosition);
                    }
                },
            );

            $(document).on(
                "click",
                'a[data-redirect-reviews="true"]',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    $.ajax({
                        url: "/api/search/redirect",
                        type: "post",
                        data: {
                            company_id: $(this).data("id"),
                            locale: jsCookie.get("locale"),
                        },
                        dataType: "json",
                        context: this,
                    }).done(function (data) {
                        if ($("#dialog_search_review_redirect").length > 0) {
                            $("#dialog_search_review_redirect").remove();
                        }
                        $("#page-content").append(
                            templateSearchReviewRedirectImmoreviews(data),
                        );
                        dialog = new mdcDialog.MDCDialog(
                            document.querySelector(
                                "#dialog_search_review_redirect",
                            ),
                        );
                        dialog.show();
                    });
                },
            );

            $(document).on(
                "click",
                'button[data-action="search"]',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    lastSearch = "regular";
                    search();
                },
            );

            $(document).on(
                "click",
                'button[data-action="show-more-result"]',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    search("next");
                },
            );

            $(document).on(
                "click",
                '.search-box-fields__city-autocomplete-list a[data-action="update-city"]',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $.ajax({
                        type: "POST",
                        url: "/api/search/location",
                        data: {
                            place_id: $(this).data("place-id"),
                        },
                        dataType: "json",
                    }).done(function (data) {
                        var latLng = new google.maps.LatLng(
                            data.geolocation.latitude,
                            data.geolocation.longitude,
                        );
                        map.setCenter(latLng);
                        map.setZoom(data.geolocation.zoom_level);
                    });
                    $(this)
                        .parent()
                        .parent()
                        .parent()
                        .find('input[name="location"]')
                        .val($(this).html());
                    $(this).parent().parent().hide();
                },
            );

            $(document).on(
                "click",
                ".search-result-pill-container .mdc-chip",
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if ($(this).data("field") != "group_id") {
                        $('form[name="form_search"]')
                            .find('[id="' + $(this).data("field") + '"]')
                            .val("");
                        $('form[name="form_search"]')
                            .find('[id="' + $(this).data("field") + '"]')
                            .focus()
                            .blur();
                    } else {
                        groupId = null;
                        $('form[name="form_search"]')
                            .find('[name="' + $(this).data("field") + '"]')
                            .val("");
                        showLoadingOverlay(".search-box-map__map-container");
                        $.ajax({
                            type: "GET",
                            url: "/api/search/map",
                            data: {
                                group_id: groupId,
                            },
                            dataType: "json",
                        }).done(function (data) {
                            googleMapApiKey = data.google.place_api_key;
                            var mapData = {
                                lat: data.geolocation.latitude,
                                lng: data.geolocation.longitude,
                                zoom_level: data.geolocation.zoom_level,
                                marker_company: data.marker_company,
                                marker_domain: data.marker_domain,
                            };

                            loadGoogleMapsApi({
                                key: data.google.place_api_key,
                            }).then(function (googleMaps) {
                                initMap(mapData, googleMaps);
                            });

                            return data;
                        });
                    }
                    $(this).remove();
                    search();
                },
            );

            $(document).on(
                "click",
                'a[data-action="show-order-menu"]',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var menu = new mdcMenu.MDCMenu(
                        $(this).next(".mdc-menu")[0],
                    );
                    menu.show();
                },
            );

            $(document).on(
                "click",
                'a[data-action="show-order-menu"] + .mdc-menu .mdc-list-item',
                function (e) {
                    $('form[name="form_search"]')
                        .find('input[name="order_by"]')
                        .val($(this).data("value"));
                    $("#order_by_label").html($(this).html());
                    search();
                },
            );

            $(document).on(
                "click",
                'a[data-ation="change-sort-direction"]',
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    switch ($(this).data("value")) {
                        case "ASC":
                            $(this).attr("data-value", "DESC");
                            $('form[name="form_search"]')
                                .find('input[name="order_direction"]')
                                .val("DESC");
                            break;
                        case "DESC":
                            $(this).attr("data-value", "ASC");
                            $('form[name="form_search"]')
                                .find('input[name="order_direction"]')
                                .val("ASC");
                            break;
                    }
                    search();
                },
            );

            $(document).on(
                "click",
                ".search-result-filter-bar__display-filter-column .mdc-tab",
                function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log($(this));
                    switch ($(this).data("value")) {
                        case "grid":
                            if (
                                $('form[name="form_search"]')
                                    .find('input[name="display"]')
                                    .val() != "grid"
                            ) {
                                $(this)
                                    .parents("#dynamic_search_result")
                                    .parent()
                                    .removeClass("list-view-item-grid");
                            }
                            break;
                        case "list":
                            if (
                                $('form[name="form_search"]')
                                    .find('input[name="display"]')
                                    .val() != "list"
                            ) {
                                $(this)
                                    .parents("#dynamic_search_result")
                                    .parent()
                                    .addClass("list-view-item-grid");
                            }
                            break;
                    }
                    $('form[name="form_search"]')
                        .find('input[name="display"]')
                        .val($(this).data("value"));
                },
            );

            new Promise(function (resolve, reject) {
                $.ajax({
                    type: "GET",
                    url: "/api/search",
                    data: {
                        group_id: groupId,
                    },
                    dataType: "json",
                })
                    .done(function (searchData) {
                        $.ajax({
                            type: "GET",
                            url: "/api/search/stats",
                            dataType: "json",
                        }).done(function (searchStats) {
                            $.each(searchStats, function (key, value) {
                                value = value
                                    .toString()
                                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                                searchStats[key] = value;
                            });
                            var data = {
                                data: searchData,
                                stats: searchStats,
                            };
                            $("#page-content").append(templateBody(data));
                            messageBar.init();
                            recommendCompany.init();
                            surveyRequest.init();
                            $(".mdc-text-field").each(function (index, value) {
                                mdcTextField.MDCTextField.attachTo($(this)[0]);
                            });
                            $(".mdc-button").each(function (index, object) {
                                mdcRipple.MDCRipple.attachTo(object);
                            });
                            $.fn.matchHeight._apply(
                                ".search-callto-action__box",
                                {
                                    property: "min-height",
                                },
                            );
                            if (groupId) {
                                $(window).scrollTop(
                                    $("#search_content").offset().top,
                                );
                                search();
                            }
                            resolve(data);
                        });
                    })
                    .fail(function (xhr, error) {
                        reject(error);
                    });
            }).then(function (result) {
                showLoadingOverlay(".search-box-map__map-container");
                $.ajax({
                    type: "GET",
                    url: "/api/search/map",
                    data: {
                        group_id: groupId,
                    },
                    dataType: "json",
                }).done(function (data) {
                    googleMapApiKey = data.google.place_api_key;
                    var mapData = {
                        lat: data.geolocation.latitude,
                        lng: data.geolocation.longitude,
                        zoom_level: data.geolocation.zoom_level,
                        marker_company: data.marker_company,
                        marker_domain: data.marker_domain,
                    };

                    loadGoogleMapsApi({
                        key: data.google.place_api_key,
                    }).then(function (googleMaps) {
                        initMap(mapData, googleMaps);
                    });

                    return data;
                });
            });
        });

        function initMap(data, google) {
            map = new google.Map(document.getElementById("map"), {
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.ControlPosition.TOP_RIGHT,
                },
                styles: [
                    {
                        featureType: "administrative",
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                color: "#444444",
                            },
                        ],
                    },
                    {
                        featureType: "landscape",
                        elementType: "all",
                        stylers: [
                            {
                                color: "#f2f2f2",
                            },
                        ],
                    },
                    {
                        featureType: "poi",
                        elementType: "all",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "road",
                        elementType: "all",
                        stylers: [
                            {
                                saturation: -100,
                            },
                            {
                                lightness: 45,
                            },
                        ],
                    },
                    {
                        featureType: "road.highway",
                        elementType: "all",
                        stylers: [
                            {
                                visibility: "simplified",
                            },
                        ],
                    },
                    {
                        featureType: "road.arterial",
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "transit",
                        elementType: "all",
                        stylers: [
                            {
                                visibility: "off",
                            },
                        ],
                    },
                    {
                        featureType: "water",
                        elementType: "all",
                        stylers: [
                            {
                                color: "#46bcec",
                            },
                            {
                                visibility: "on",
                            },
                        ],
                    },
                ],
            });

            map.data.setStyle({
                strokeWeight: 1,
                strokeColor: "#1E90FF",
                fillOpacity: 0.45,
                fillColor: "#1E90FF",
            });

            //There are 5 levels, m1.png to ... m5.png
            var styles = [
                {
                    fontFamily: "'Open Sans', Arial",
                    fontWeight: "400",
                    textColor: "#fff",
                    url:
                        "https://" +
                        data.marker_domain +
                        "/image/search-map/os_m1.png",
                    height: 52,
                    width: 53,
                },
                {
                    fontFamily: "'Open Sans', Arial",
                    fontWeight: "400",
                    textColor: "#fff",
                    url:
                        "https://" +
                        data.marker_domain +
                        "/image/search-map/os_m2.png",
                    height: 55,
                    width: 56,
                },
                {
                    fontFamily: "'Open Sans', Arial",
                    fontWeight: "400",
                    textColor: "#fff",
                    url:
                        "https://" +
                        data.marker_domain +
                        "/image/search-map/os_m3.png",
                    height: 65,
                    width: 66,
                },
                {
                    fontFamily: "'Open Sans', Arial",
                    fontWeight: "400",
                    textColor: "#fff",
                    url:
                        "https://" +
                        data.marker_domain +
                        "/image/search-map/os_m4.png",
                    height: 77,
                    width: 78,
                },
                {
                    fontFamily: "'Open Sans', Arial",
                    fontWeight: "400",
                    textColor: "#fff",
                    url:
                        "https://" +
                        data.marker_domain +
                        "/image/search-map/os_m5.png",
                    height: 89,
                    width: 90,
                },
            ];

            var markerClusterOptions = {
                styles: styles,
            };
            markerCluster = new markerClusterer(
                map,
                null,
                markerClusterOptions,
            );

            if (data.marker_company.length > 0) {
                addCompanyMarker(
                    data.marker_domain,
                    data.marker_company,
                    google,
                );
            }

            google.event.addListener(map, "dragend", function () {
                if (mapLoaded) {
                    lastSearch = "map";
                    search();
                }
            });
            google.event.addListener(map, "zoom_changed", function () {
                if (mapLoaded) {
                    lastSearch = "map";
                    search();
                }
            });
            hideLoadingOverlay(".search-box-map__map-container");
        }

        function addCompanyMarker(markerDomain, data, google) {
            var markers = [];
            var bounds = new google.LatLngBounds();
            var osMarker = {
                url: "https://" + markerDomain + "/image/search-map/os.png",
            };
            for (var i = 0; i < data.length; i++) {
                if (data[i].lat != 0 && data[i].lng != 0) {
                    var marker = new google.Marker({
                        map: map,
                        position: new google.LatLng(data[i].lat, data[i].lng),
                        icon: osMarker,
                    });
                    markers.push(marker);
                    bounds.extend(marker.getPosition());
                }
            }
            markerCluster.clearMarkers();
            markerCluster.addMarkers(markers);
            map.fitBounds(bounds);
            setTimeout(() => {
                mapLoaded = true;
            }, 1000);
        }

        function search(type) {
            showLoadingOverlay();

            if (lastSearch == "map") {
                var bounds = map.getBounds();
                var ne = bounds.getNorthEast(); // LatLng of the north-east corner
                var sw = bounds.getSouthWest(); // LatLng of the south-west corder
                var nw = new google.maps.LatLng(ne.lat(), sw.lng());
                var se = new google.maps.LatLng(sw.lat(), ne.lng());
                mapBoundries = {
                    ne: [ne.lat(), ne.lng()],
                    nw: [nw.lat(), nw.lng()],
                    sw: [sw.lat(), sw.lng()],
                    se: [se.lat(), se.lng()],
                };
            }

            $.ajax({
                type: "POST",
                url: "/api/search/list",
                data: {
                    query: $(
                        'form[name="form_search"] input[name="query"]',
                    ).val(),
                    location: $(
                        'form[name="form_search"] input[name="location"]',
                    ).val(),
                    limit_start:
                        type == "next"
                            ? $('button[data-action="show-more-result"]').data(
                                  "next-limit",
                              )
                            : null,
                    iso_code: $(
                        'form[name="form_search"] input[name="iso_code"]',
                    ).val(),
                    coordinate: lastSearch == "map" ? mapBoundries : null,
                    order_by: $(
                        'form[name="form_search"] input[name="order_by"]',
                    ).val(),
                    order_direction: $(
                        'form[name="form_search"] input[name="order_direction"]',
                    ).val(),
                    display: $(
                        'form[name="form_search"] input[name="display"]',
                    ).val(),
                    group_id: $(
                        'form[name="form_search"] input[name="group_id"]',
                    ).val(),
                },
                dataType: "json",
                async: false,
            }).done(function (data) {
                if (data.initial_search) {
                    $("#search_content")
                        .empty()
                        .append(templateSearchResult(data));
                    initializeResultDisplayTab();
                } else {
                    $("#dynamic_search_result").append(
                        templateSearchResult(data),
                    );
                }
                if (data.total < 9) {
                    $('button[data-action="show-more-result"]').hide();
                } else {
                    $('button[data-action="show-more-result"]').data(
                        "next-limit",
                        data.next_limit,
                    );
                }
            });
            hideLoadingOverlay();
        }

        function showLoadingOverlay(target) {
            if (typeof target === "undefined") {
                target = "body";
            }
            $(target).plainOverlay("show", {
                progress: function () {
                    return $('<div class="plain-overlay__icon"></div>');
                },
            });
        }

        function hideLoadingOverlay(target) {
            if (typeof target === "undefined") {
                target = "body";
            }
            $(target).plainOverlay("hide");
        }

        function initializeResultDisplayTab() {
            $(".search-result-filter-bar .mdc-tab").each(
                function (index, value) {
                    dynamicTab = new mdcTab.MDCTab($(this)[0]);
                    dynamicTab.preventDefaultOnClick = true;
                    dynamicTab.listen("MDCTab:interacted", function (t) {
                        $(".search-result-filter-bar .mdc-tab").removeClass(
                            "mdc-tab--active",
                        );
                        $(
                            ".search-result-filter-bar .mdc-tab .mdc-tab-indicator",
                        ).removeClass("mdc-tab-indicator--active");
                        $(
                            '.search-result-filter-bar .mdc-tab[href="' +
                                t.target.hash +
                                '"]',
                        ).addClass("mdc-tab--active");
                        $(
                            '.search-result-filter-bar .mdc-tab[href="' +
                                t.target.hash +
                                '"] .mdc-tab-indicator',
                        ).addClass("mdc-tab-indicator--active");
                    });
                },
            );
        }

        function showPosition(position) {
            map.setCenter({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            });
        }
    });
});
